module.exports = __webpack_public_path__ + "static/media/member-emblem-pink.3ebf0a21.png";